import config from "../config";

declare const window: Window & { dataLayer: Record<string, unknown>[]; }; // Google Analytics dataLayer

export default class AnalyticsManager
{
	static managedClick(clickId: string, category = "")
	{
		if (!config.ANALYTICS) return;
		this.managedEvent('managedClick', 'managedClickId', { category: category ? category : "General", id: clickId });
	}

	static managedEvent(eventId: string, eventDataId = "", eventData?: any, eventCategory?: any)
	{
		if (!config.ANALYTICS) return;
		if (eventDataId)
		{
			const eventDataObj = {
				[eventDataId]: eventCategory ? { data: eventData, category: eventCategory } : eventData,
			};
			window.dataLayer.push(eventDataObj);
		}

		if (eventId)
		{
			window.dataLayer.push({ event: eventId });
		}
	}
}